
import Vue from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { BFormSelect } from "bootstrap-vue";
import axios from "axios";
import  { KeyValuePairOfIntegerAndString } from '../../types/Sapphire_dto';

export default Vue.extend({
  name: "region-dashboard-vue-component",
  components: {
    BFormSelect,
    vSelect,
  },
  props: {
    
  },
  computed: {
   
  },
  data: function () {
    return {
        Regions: [] as KeyValuePairOfIntegerAndString[],
        Profiles: [] as KeyValuePairOfIntegerAndString[],
        selectedRegion: null,
        selectedProfiles: [],
    };
    

    
  },
  mounted() {
   this.getRegions();
   this.getProfiles();
  },
  watch: {
    selectedRegion: async function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.GetRegionProfiles();
      }
    },
    
  },
  methods: {


    async getRegions() {
        const response = await axios.post("../../Common/Services/EmarClientOperations.svc/GetRegions");

        // Parse and map response to match expected structure
        this.Regions = JSON.parse(response.data.d).map((region: any) => ({
            Key: region.key, 
            Value: region.value
        }));

        // Prepend a default option
        //this.Regions.unshift({ Key: 0, Value: 'Select a region' });
    },
    async getProfiles() {
        const response = await axios
            .post("../../Common/Services/EmarClientOperations.svc/GetDashboardProfiles");
        
        const responseData = JSON.parse(response.data.d) as KeyValuePairOfIntegerAndString[];
        
         this.Profiles = responseData;
         this.Profiles = responseData.filter(profile => profile.Key !== -1);
         
         
    },
     async SaveRegionProfiles() {
      await axios
          .post(
            "../../../Common/Services/EmarClientOperations.svc/SaveRegionProfiles",
            {
              Profiles: this.selectedProfiles,
              Region: this.selectedRegion.Key
            }
          )
          this.$bvToast.show("save-toast");
    },
     async GetRegionProfiles() {
      if(this.selectedRegion) {
        await axios
          .post(
            "../../../Common/Services/EmarClientOperations.svc/GetRegionProfiles",
            {
              Region: this.selectedRegion.Key
            }
          )
           .then((response) => {
            this.selectedProfiles = [];
            this.selectedProfiles = JSON.parse(response.data.d);
            })
            .catch(function() {
            // handle error
            // eslint-disable-next-line no-undef
            // tb_remove2();
            });
      }
    },
  },
});

